if (!customElements.get('cart-drawer-recommendation-card')) {
  customElements.define(
    'cart-drawer-recommendation-card',
    class CartDrawerRecommendationCard extends HTMLElement {
      constructor() {
        super();
        this.addButton = this.querySelector('[data-recommendation-add]');
        this.cancelButton = this.querySelector('[data-recommendation-cancel]');
        this.variantsPanel = this.querySelector('[data-recommendation-variants]');
        this.variantInput = this.querySelector('[name="id"]');
        this.submitButton = this.querySelector('[data-recommendation-submit]');
        this.variantButtons = this.querySelectorAll('[data-variant-id]');

        this.onAddClick = this.onAddClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.onVariantClick = this.onVariantClick.bind(this);
      }

      connectedCallback() {
        this.addButton?.addEventListener('click', this.onAddClick);
        this.cancelButton?.addEventListener('click', this.onCancelClick);
        this.variantButtons.forEach((button) => button.addEventListener('click', this.onVariantClick));
      }

      disconnectedCallback() {
        this.addButton?.removeEventListener('click', this.onAddClick);
        this.cancelButton?.removeEventListener('click', this.onCancelClick);
        this.variantButtons.forEach((button) => button.removeEventListener('click', this.onVariantClick));
      }

      onAddClick(event) {
        event.preventDefault();
        if (!this.variantsPanel) {
          this.submitSelectedVariant();
          return;
        }
        this.openVariants();
      }

      onCancelClick(event) {
        event.preventDefault();
        this.closeVariants();
      }

      onVariantClick(event) {
        event.preventDefault();
        const button = event.currentTarget;
        if (button.disabled || !button.dataset.variantId) return;

        if (this.variantInput) {
          this.variantInput.value = button.dataset.variantId;
          this.variantInput.disabled = false;
        }
        if (this.submitButton) this.submitButton.disabled = false;
        this.submitSelectedVariant();
      }

      openVariants() {
        this.classList.add('is-selecting-variant');
        this.addButton?.setAttribute('hidden', '');
        this.addButton?.setAttribute('aria-expanded', 'true');
        this.variantsPanel?.removeAttribute('hidden');
      }

      closeVariants() {
        this.classList.remove('is-selecting-variant');
        this.addButton?.removeAttribute('hidden');
        this.addButton?.setAttribute('aria-expanded', 'false');
        this.variantsPanel?.setAttribute('hidden', '');
      }

      submitSelectedVariant() {
        const form = this.querySelector('form');
        const productForm = this.querySelector('product-form');
        if (!form || !this.submitButton) return;

        // Keep loading state on the visible CTA while the hidden submit fires.
        this.addButton?.classList.add('loading');
        this.addButton?.setAttribute('aria-disabled', 'true');

        const spinner = this.addButton?.querySelector('.loading__spinner');
        spinner?.classList.remove('hidden');

        const clearLoading = () => {
          this.addButton?.classList.remove('loading');
          this.addButton?.removeAttribute('aria-disabled');
          spinner?.classList.add('hidden');
          productForm?.removeEventListener('submit', clearLoading);
        };

        // Fallback clear if cart replace removes the node before events settle.
        setTimeout(clearLoading, 4000);

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(this.submitButton);
        } else {
          this.submitButton.click();
        }
      }
    }
  );
}
